import { pick } from '@eastcoal/common/utils/object'

import { ImageBox } from '../Box'
import { ImageDesc } from '../Desc'
import { ImageError } from '../Error'
import { useUpdateImageSize } from '../hooks/useUpdateImageSize'
import { ImageLoading } from '../Loading'
import { useImageCardStore } from '../Store/hooks/useStore'
import { ImageToolbar } from '../Toolbar'

export const ImageCore = () => {
  const { error, loading } = useImageCardStore(state =>
    pick(state, ['ossUrl', 'error', 'loading', 'setOriginalSize'])
  )

  useUpdateImageSize()

  return loading ? (
    <ImageLoading />
  ) : error ? (
    <ImageError />
  ) : (
    <>
      <ImageToolbar>
        <ImageBox />
      </ImageToolbar>
      <ImageDesc />
    </>
  )
}
